import React from 'react';
export function Shell({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`mx-auto w-full max-w-shell px-6 md:px-10 lg:px-14 ${className}`} data-id="element-541" data-mp="32zd5lh0c6hid">{children}</div>;
}
export function Eyebrow({
  children,
  onDark,
  className = ''
}: {
  children: React.ReactNode;
  onDark?: boolean;
  className?: string;
}) {
  return <p className={`font-sans text-eyebrow uppercase ${onDark ? 'text-navy-200' : 'text-charcoal-300'} ${className}`} data-id="element-542" data-mp="3gy4fer861h0p">
      {children}
    </p>;
}
export function GoldRule({
  className = ''
}: {
  className?: string;
}) {
  return <div aria-hidden="true" className={`h-px w-11 bg-gold ${className}`} data-id="element-543" data-mp="3qoz3m14z2qos" />;
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  onDark,
  as: As = 'h2',
  align = 'left'
}: {
  eyebrow?: string;
  title: string;
  intro?: React.ReactNode;
  onDark?: boolean;
  as?: 'h1' | 'h2' | 'h3';
  align?: 'left' | 'center';
}) {
  return <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-544" data-mp="8fyi42jtc186">
      <GoldRule className={align === 'center' ? 'mx-auto' : ''} data-id="element-545" data-mp="10c12504mwrti" />
      {eyebrow ? <Eyebrow onDark={onDark} className="mt-5" data-id="element-546" data-mp="ve98a0kfivmo">{eyebrow}</Eyebrow> : null}
      <As className={`mt-3 font-serif text-[1.75rem] leading-[1.15] tracking-[-0.01em] md:text-[2.25rem] ${onDark ? 'text-parchment' : 'text-ink'}`} data-id="element-547" data-mp="rcnt28kfa59b">
        {title}
      </As>
      {intro ? <div className={`mt-5 font-serif text-[1.0625rem] leading-relaxed ${onDark ? 'text-navy-100' : 'text-charcoal-500'}`} data-id="element-548" data-mp="1j43peubs76cq">
          {intro}
        </div> : null}
    </div>;
}
export function Section({
  children,
  tone = 'white',
  className = '',
  labelledBy
}: {
  children: React.ReactNode;
  tone?: 'white' | 'parchment' | 'navy' | 'ink';
  className?: string;
  labelledBy?: string;
}) {
  const tones = {
    white: 'bg-white',
    parchment: 'bg-parchment',
    navy: 'bg-navy-700 on-dark',
    ink: 'bg-ink on-dark'
  } as const;
  return <section aria-labelledby={labelledBy} className={`${tones[tone]} py-16 md:py-24 ${className}`} data-id="element-549" data-mp="2gxuvib8zizgf">
      <Shell data-id="element-550" data-mp="2lxhb2rcacrse">{children}</Shell>
    </section>;
}